<template>
  <div
    class="
      EmptyRequest
      w-100
      h-100
      p-0
      row
      center-xs center-md center-sm center-xs
      mt-3
    "
  >
    <img :src="emptyIcon" class="empty" />
    <span v-if="!hasFilters">Não há {{ dataTitle }} para exibir.</span>
    <span v-else>Não há {{ dataTitle }} correspondentes a busca para exibir.</span>
  </div>
</template>

<script>
import emptyIcon from "@/assets/icons/Empty.svg";

export default {
  props: {
    dataTitle: {
      type: String,
      default: "dados"
    },
    hasFilters: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      emptyIcon,
    }
  }
}
</script>